var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGitDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1,
    strokeWidth: 0.833,
    d: "M19.622 9.108 10.889.377a1.29 1.29 0 0 0-1.823 0l-1.81 1.812 2.3 2.3a1.532 1.532 0 0 1 1.94 1.951l2.215 2.217a1.532 1.532 0 0 1 1.086 2.865 1.53 1.53 0 0 1-2.087-1.114 1.54 1.54 0 0 1 .08-.882l-2.073-2.064V12.9c.146.072.285.17.406.29a1.54 1.54 0 0 1 0 2.167 1.535 1.535 0 0 1-2.174 0 1.527 1.527 0 0 1 0-2.165 1.6 1.6 0 0 1 .504-.339v-5.49a1.53 1.53 0 0 1-.83-2.009l-2.26-2.27L.375 9.066c-.5.505-.5 1.32 0 1.825l8.733 8.73a1.29 1.29 0 0 0 1.822 0l8.692-8.691a1.286 1.286 0 0 0 0-1.823"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitDark);
export default __webpack_public_path__ + "static/media/git-dark.ebad4cc6735150d13ee845ae24258bf0.svg";
export { ForwardRef as ReactComponent };